import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import TestForm from "../form";
import { jwtDecode } from "jwt-decode";
import DatePicker from "react-datepicker";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { getNames } from "country-list";
import axios from "axios";
import RequiredTestsDropdown from "../requesttest";
import ResuestSample from "../requestsample";
import { MdDelete, MdDeleteOutline } from "react-icons/md";
function ViewForm() {
    const baseUrl =
        process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_BASE_URL_DEV
            : process.env.REACT_APP_BASE_URL_PROD;
    AOS.init();
    const [showAdditionalContent, setShowAdditionalContent] = useState(false);
    const [userInfo1, setUserInfo1] = useState({});

    const [packageInfo, setPackageInfo] = useState([]);
    const location = useLocation();
    const [showContent, setShowContent] = useState(false);
    const queryParams = new URLSearchParams(location.search);
    const categoryId = queryParams.get("id");
    const navigate = useNavigate();
    const tokenn = localStorage.getItem("aqua");
    const [book, setBook] = useState(false);
    const [book2, setBook2] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [popup, setPopup] = useState({
        visible: false,
        message: "",
        isError: false,
    });
    const [popup12, setPopup12] = useState({
        visible: false,
        message: "",
        isError: false,
    });
    const [loggedIn, setLoggedIn] = useState(false);

    const [formData, setFormData] = useState({
        title: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        gender: "",
        address1: "",
        address2: "",
        clinicName: "",
        postalCode: "",
        country: "",
        nhsNumber: "",
        requiredTests: [],
        TubesNumber: "",
        fasting: false,
        clinicComplain: "",
        additionalRemark: "",

        promtotionCode: "",
        dob: null,
        SerumTypes: [],
        Pregnant: false,
        patientname: "",
        patientnumber: "",
        patientemail: "",
        city: "",
        streetname: "",
        // isClickInOwner :''
    });

    //
    const [formData1, setFormData1] = useState({
        clinicName1: "",
        phoneNumber1: "",
        email1: "",
        address11: "",
        materials: [
            {
                materialName: "",
                qty: "",
                unit: "",
                manufacturerName: "",
                batchNumber: "",
                expiryDate: "",
            },
        ],
    });

    const handleChange1 = (e) => {
        const { name, value } = e.target;
        setFormData1((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handlePhoneNumberChange12 = (value) => {
        setFormData1((prevData) => ({
            ...prevData,
            phoneNumber1: value,
        }));
    };

    const addMaterialRow = () => {
        setFormData1((prevData) => ({
            ...prevData,
            materials: [
                ...(prevData.materials || []),
                {
                    materialName: "",
                    qty: "",
                    unit: "",
                    manufacturerName: "",
                    batchNumber: "",
                    expiryDate: "",
                },
            ],
        }));
    };

    const handleMaterialChange = (index, e) => {
        const { name, value } = e.target;
        setFormData1((prevData) => {
            const newMaterials = [...prevData.materials];
            newMaterials[index][name] = value;
            return { ...prevData, materials: newMaterials };
        });
    };

    const removeMaterialRow = (index) => {
        setFormData1((prevData) => ({
            ...prevData,
            materials: prevData.materials.filter((_, i) => i !== index),
        }));
    };

    const handleBooking1 = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${baseUrl}/booking/sampleRequest`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("aqua")}`,
                },
                body: JSON.stringify(formData1),
            });

            const result = await response.json();
            if (result.isSuccess) {
                showPopup12("Sample request submitted successfully!", false);
                setFormData1({
                    clinicName1: "",
                    phoneNumber1: "",
                    email1: "",
                    address11: "",
                    materials: [
                        {
                            materialName: "",
                            qty: "",
                            unit: "",
                            manufacturerName: "",
                            batchNumber: "",
                            expiryDate: "",
                        },
                    ],
                });
            } else {
                showPopup12("Failed to submit sample request.", true);
            }
        } catch (error) {
            console.error("Error submitting sample request:", error);
            showPopup12("An error occurred. Please try again.", true);
        }
    };

    const showPopup12 = (message, isError = false) => {
        setPopup12({
            visible: true,
            message,
            isError,
        });
        setBook2(!book2);
    };

    const closePopup12 = () => {
        setPopup12((prev) => ({
            ...prev,
            visible: false,
        }));
        setBook2(!book2);
    };
    //

    // const userInfo = jwtDecode(tokenn);

    const countries = getNames();
    const modifiedCountries = [...countries, "United Kingdom"];

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const response = await fetch(
                    `${baseUrl}/home/category?categoryId=${categoryId}`
                );
                if (!response.ok) {
                    throw new Error("Unable to fetch data");
                }
                const data = await response.json();
                setPackageInfo(data);
            } catch (error) {
                console.error("Error fetching services:", error);
                setPackageInfo([]);
            }
        };

        fetchServices();
    }, [categoryId]);

    const handleLearnMoreClick = () => {
        if (categoryId === "7") {
            setShowAdditionalContent(true);
        }
    };

    // cus

    useEffect(() => {
        const token = localStorage.getItem("aqua");
        if (!token) {
            console.error("No token found");
            return;
        }

        const jwt = jwtDecode(token);
        // console.log(jwt);

        fetch(`${baseUrl}/userInfo/getUserDetails`, {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error("Failed to fetch user details");
                }
            })
            .then((data) => {
                if (data && data.result) {
                    setUserInfo1(data.result);
                    setFormData({
                        title: data.result.Title || "",
                        firstName: data.result.FirstName || "",
                        lastName: data.result.LastName || "",
                        phoneNumber: data.result.PhoneNumber || "",
                        email: data.result.Email || "",
                        address1: data.result.ClinicAddress || "",
                        clinicName: data.result.ClinicName || "",
                    });
                    setFormData1({
                        phoneNumber1: data.result.PhoneNumber || "",
                        email1: data.result.Email || "",
                        address11: data.result.ClinicAddress || "",
                        clinicName1: data.result.ClinicName || "",
                    });
                } else {
                    console.error("API returned undefined result:", data);
                }
            })
            .catch((error) => {
                console.error("Error fetching user details:", error);
            });

        const fakeDatafetch = () => {
            setTimeout(() => {
                setIsLoading(false);
            }, 1000);
        };
        fakeDatafetch();
    }, [baseUrl]);

    const handleViewFormClick = () => {
        setBook(!book);
    };
    const handleViewFormClick2 = () => {
        setBook2(!book2);
    };

    const closePopup = () => {
        setPopup({ ...popup, visible: false });
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handlePhoneNumberChange = (phone) => {
        setFormData({ ...formData, phoneNumber: phone });
    };

    const handlePhoneNumberChange1 = (phone) => {
        setFormData({ ...formData, patientnumber: phone });
    };

    const handleBookingDateChange = (date) => {
        setFormData({ ...formData, bookingDate: date });
    };

    const handleDobChange = (date) => {
        setFormData({ ...formData, dob: date });
    };

    const handleChange12 = (e) => {
        const { name, type, checked } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === "checkbox" ? checked : prevData[name],
        }));
    };

    const handleDateChange = (date) => {
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        const hours = date.getHours() % 12 || 12;
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const amPm = date.getHours() >= 12 ? "PM" : "AM";

        const formattedDateTime = `${day}-${month}-${year} ${hours}:${minutes} ${amPm}`;

        setFormData((prevState) => ({
            ...prevState,
            bookingDate: formattedDateTime,
        }));
    };

    const handleDateChange1 = (date) => {
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        const formattedDate = `${day}-${month}-${year}`;

        setFormData((prevState) => ({
            ...prevState,
            dob: formattedDate,
        }));
    };

    const handleBooking = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post(
                `${baseUrl}/booking/addcustomized`,
                formData
            );

            if (response.data.success) {
                setBook(false);

                setPopup({
                    visible: true,
                    message: "Request successfully submitted!",
                    isError: false,
                });

                setFormData({
                    title: "",
                    firstName: "",
                    lastName: "",
                    phoneNumber: "",
                    email: "",
                    gender: "",
                    address1: "",
                    address2: "",
                    clinicName: "",
                    postalCode: "",
                    country: "",
                    nhsNumber: "",
                    requiredTests: "",
                    serumTypes: "",
                    fastingOrPregnant: "",
                    clinicComplain: "",
                    additionalRemark: "",
                    city: "",
                    streetname: "",
                    // bookingDate: null,
                    dob: null,
                });
            } else {
                setPopup({
                    visible: true,
                    message: "Failed to submit booking. Please try again.",
                    isError: true,
                });
            }
        } catch (error) {
            console.error(error);
            setPopup({
                visible: true,
                message: "Failed to submit booking. Please try again.",
                isError: true,
            });
        }
    };

    //

    const handleGoBack = () => {
        window.history.back();
    };

    useEffect(() => {
        const token = localStorage.getItem("aqua");
        // console.log(token);
        if (token != null) {
            const userInfo = jwtDecode(token);
            setLoggedIn(true);
        }
    }, []);
    return (
        <>
            {userInfo1.IsClinicOwner === "yes" &&
                loggedIn && (
                    <div>
                        <button
                            onClick={handleViewFormClick}
                            className="flex  gap-2 items-center text-[10px] xl:text-[18px] justify-between xl:pr-2 xl:pl-4 xl:pl-2 lg:px-1 lg:w-auto xl:h-[40px] h-[30px] w-auto bg-[#ffffff] text-[#234971] hover:bg-[#234971] hover:text-[#ffffff] border-2 hover:border-[#ffffff] transition-all duration-300 rounded-[40px] font-[600]"
                        >
                            View Form
                            <img
                                src="../assets/hero/more.png"
                                alt=""
                                className="bg-[#234971] xl:h-[30px] h-[27px] rounded-full lg:p-2 p-1"
                            />
                        </button>
                    </div>
                )}
            {book && (
                <div className="fixed top-0 left-0 bottom-0 right-0 p-4 z-50  left-0 w-full h-full bg-black bg-opacity-[40%] grid place-content-center figtree px-3 md:px-0">

                    <div className=" lg:mx-[80px] h-[600px] mx-5 text-[#ffffff] border-[1px] border-white relative   bg-[#11485B] overflow-scroll scroll  md:rounded-[30px] rounded-[20px] lg:px-10 px-5 py-2">
                        <form onSubmit={handleBooking}>
                            <div
                                className="absolute md:right-6 md:top-5 right-4  cursor-pointer"
                                onClick={handleViewFormClick}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="2"
                                    stroke="currentColor"
                                    className="w-4 h-4"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M6 18L18 6M6 6l12 12"
                                    />
                                </svg>
                            </div>

                            {userInfo1.IsClinicOwner === "no" ||
                                (!loggedIn && (
                                    <>
                                        <p className=" text-[14px] md:text-[18px] font-[600] md:py-1">
                                            Enter the Patient Details
                                        </p>
                                        <p className=" text-[14px] md:text-[18px]  font-[300] my-2 text-justify">
                                            Our administrative team will contact
                                            you using the details provided.
                                            Please ensure all information
                                            entered is accurate.
                                        </p>
                                    </>
                                ))}
                            {userInfo1.IsClinicOwner === "yes" &&
                                loggedIn && (
                                    <p className=" text-[14px] md:text-[18px] font-[600] md:py-1">
                                        Business Details
                                    </p>
                                )}
                            <div className="md:flex gap-3 md:mt-7">
                                <div className="inputbox text-black">
                                    <select
                                        name="title"
                                        id="title"
                                        value={formData.title}
                                        onChange={handleChange}
                                        className="w-full h-12 px-4 border-2 rounded-md custom-select"
                                        required
                                    >
                                        <option value="">Title*</option>
                                        <option value="Mr.">Mr.</option>
                                        <option value="Mrs.">Mrs.</option>
                                        <option value="Miss.">Miss.</option>
                                        <option value="Dr.">Dr.</option>
                                    </select>
                                </div>
                                <div className="inputbox">
                                    <input
                                        type="text"
                                        name="firstName"
                                        value={formData.firstName}
                                        onChange={handleChange}
                                        required
                                    />
                                    <span className="">First Name*</span>
                                    <i></i>
                                </div>
                                <div className="inputbox">
                                    <input
                                        type="text"
                                        name="lastName"
                                        value={formData.lastName}
                                        onChange={handleChange}
                                        required
                                    />
                                    <span>Last Name*</span>
                                    <i></i>
                                </div>
                            </div>

                            <div className="md:flex gap-3 md:mt-2">
                                <div className="inputbox custom-phone-input">
                                    <PhoneInput
                                        defaultCountry="GB"
                                        value={formData.phoneNumber}
                                        onChange={handlePhoneNumberChange}
                                        name="phoneNumber"
                                        placeholder="Phone Number*"
                                        international
                                        withCountryCallingCode
                                    // containerClass="custom-phone-input"
                                    />
                                </div>

                                <div className="inputbox">
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                    <span> Email*</span>
                                    <i></i>
                                </div>

                                {userInfo1.IsClinicOwner === "yes" &&
                                    loggedIn && (
                                        <div className="inputbox">
                                            <input
                                                type="text"
                                                name="address1"
                                                value={formData.address1}
                                                onChange={handleChange}
                                                required
                                            />
                                            <span>Business Address*</span>
                                            <i></i>
                                        </div>
                                    )}
                            </div>

                            {userInfo1.IsClinicOwner === "yes" &&
                                loggedIn && (
                                    <>
                                        <p className=" text-[14px] md:text-[18px] font-[600] md:py-1">
                                            Enter the Patient Details
                                        </p>

                                        <div className="md:flex gap-3 md:mt-7">
                                            <div className="inputbox">
                                                <input
                                                    type="text"
                                                    name="patientname"
                                                    value={formData.patientname}
                                                    onChange={handleChange}
                                                    required
                                                />
                                                <span className="">
                                                    Patient Name*
                                                </span>
                                                <i></i>
                                            </div>
                                            <div className="inputbox custom-phone-input">
                                                <PhoneInput
                                                    defaultCountry="GB"
                                                    value={formData.patientnumber}
                                                    onChange={
                                                        handlePhoneNumberChange1
                                                    }
                                                    name="patientnumber"
                                                    placeholder="Phone Number*"
                                                    international
                                                    withCountryCallingCode
                                                // containerClass="custom-phone-input"
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}

                            <div className="md:flex gap-3 md:mt-2">
                                {userInfo1.IsClinicOwner === "yes" &&
                                    loggedIn && (
                                        <div className="inputbox">
                                            <input
                                                type="email"
                                                name="patientemail"
                                                value={formData.patientemail}
                                                onChange={handleChange}
                                                required
                                            />
                                            <span> Patient Email*</span>
                                            <i></i>
                                        </div>
                                    )}

                                <div className="inputbox">
                                    <input
                                        type="text"
                                        name="address2"
                                        value={formData.address2}
                                        onChange={handleChange}
                                        required
                                    />
                                    <span> Patient Address* </span>
                                    <i></i>
                                </div>
                            </div>

                            <div className="md:flex gap-3 md:mt-2">
                                <div className="inputbox">
                                    <input
                                        type="text"
                                        name="streetname"
                                        value={formData.streetname}
                                        onChange={handleChange}
                                        required
                                    />
                                    <span>Street Name and Number*</span>
                                    <i></i>
                                </div>

                                <div className="inputbox">
                                    <input
                                        type="text"
                                        name="city"
                                        value={formData.city}
                                        onChange={handleChange}
                                        required
                                    />
                                    <span>City*</span>
                                    <i></i>
                                </div>
                            </div>
                            <div className="md:flex gap-3 md:mt-2">
                                <div className="inputbox">
                                    <input
                                        type="text"
                                        name="postalCode"
                                        value={formData.postalCode}
                                        onChange={handleChange}
                                        required
                                    />
                                    <span>Postal Code*</span>
                                    <i></i>
                                </div>

                                <div className="inputbox z-10">
                                    <div className="select-wrapper">
                                        <select
                                            name="country"
                                            value={formData.country}
                                            onChange={handleChange}
                                            id="country"
                                            className="w-full custom-select h-12 px-4 rounded-md"
                                            required
                                        >
                                            <option value="">
                                                Select Country*
                                            </option>
                                            {modifiedCountries.map(
                                                (country, index) => (
                                                    <option
                                                        key={index}
                                                        value={country}
                                                    >
                                                        {country}
                                                    </option>
                                                )
                                            )}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="md:flex gap-3 md:mt-2">
                                <div className="inputbox">
                                    <div className="select-wrapper">
                                        <select
                                            name="gender"
                                            value={formData.gender}
                                            onChange={handleChange}
                                            className="custom-select"
                                            required
                                        >
                                            <option value="" className="">
                                                Select Gender*
                                            </option>
                                            <option value="Male">Male</option>
                                            <option value="Female">
                                                Female
                                            </option>
                                            <option value="Other">Other</option>
                                        </select>
                                        <i className="highlight"></i>
                                    </div>
                                </div>
                                <div className="inputbox">
                                    <input
                                        type="text"
                                        name="nhsNumber"
                                        value={formData.nhsNumber}
                                        onChange={handleChange}
                                        required
                                    />
                                    <span>Patient NHS number</span>
                                    <i></i>
                                </div>

                            </div>

                            <div className="md:flex gap-3 md:mt-2">



                            </div>
                            <div className="md:flex gap-3">



                                <div className="inputbox">
                                    <input type="text" name="promotionCode"
                                        value={formData.promtotionCode}
                                        onChange={handleChange} required />
                                    <span>Promotion Code</span>
                                    <i></i>
                                </div>
                                <div className="inputbox ">
                                    <div className="select-wrapper ">
                                        <RequiredTestsDropdown
                                            formData={formData}
                                            setFormData={setFormData}
                                        />
                                        <ul>
                                            {Array.isArray(formData.requiredTests) &&
                                                formData.requiredTests.length > 0 &&
                                                formData.requiredTests.map((category, index) => (
                                                    <li key={index}>
                                                        {category}
                                                    </li>
                                                ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {userInfo1.IsClinicOwner === "yes" &&
                                loggedIn && (
                                    <div className="md:flex gap-3 md:mt-2 ">
                                        <div className="inputbox">
                                            <div className="!w-full">
                                                <input
                                                    type="text"
                                                    name="TubesNumber"
                                                    value={formData.TubesNumber}
                                                    onChange={handleChange}
                                                    required
                                                />
                                                <span> Tubes Number </span>
                                                <i></i>
                                            </div>
                                        </div>

                                        <div className="inputbox">
                                            <div className="select-wrapper">
                                                <ResuestSample
                                                    formData={formData}
                                                    setFormData={setFormData}
                                                />
                                                <ul>
                                                    {Array.isArray(
                                                        formData.SerumTypes
                                                    ) &&
                                                        formData.SerumTypes.length >
                                                        0 &&
                                                        formData.SerumTypes.map(
                                                            (test) => (
                                                                <li key={test.value}>
                                                                    {test.label}
                                                                </li>
                                                            )
                                                        )}
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="border-[1px] border-[#4ab0b0] rounded-[6px] w-full h-[48px]">
                                            <div className="flex items-center h-full justify-around">
                                                <div className="flex items-center gap-4">
                                                    <label
                                                        htmlFor="fasting"
                                                        className=""
                                                    >
                                                        <p className="">Fasting </p>
                                                    </label>
                                                    <input
                                                        type="checkbox"
                                                        id="fasting"
                                                        name="fasting"
                                                        checked={formData.fasting}
                                                        onChange={handleChange12}
                                                        className="form-checkbox h-5 w-5"
                                                    />
                                                </div>

                                                <div className="flex items-center gap-4">
                                                    <label
                                                        htmlFor="Pregnant"
                                                        className=""
                                                    >
                                                        <p className="">Pregnant </p>
                                                    </label>
                                                    <input
                                                        type="checkbox"
                                                        id="Pregnant"
                                                        name="Pregnant"
                                                        checked={formData.Pregnant}
                                                        onChange={handleChange12}
                                                        className="form-checkbox h-5 w-5"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                            <div className="md:flex gap-3 md:mt-2 ">
                                <div className="inputbox">
                                    <div className="!w-full">
                                        <input
                                            type="text"
                                            name="clinicComplain"
                                            value={formData.clinicComplain}
                                            onChange={handleChange}
                                            required
                                        />
                                        <span> Clinical Complain </span>
                                        <i></i>
                                    </div>
                                </div>

                                <div className="inputbox">
                                    <div className="!w-full">
                                        <input
                                            type="text"
                                            name="additionalRemark"
                                            value={formData.additionalRemark}
                                            onChange={handleChange}
                                            required
                                        />
                                        <span> Additional remark </span>
                                        <i></i>
                                    </div>
                                </div>
                            </div>
                            <div className="md:flex gap-3 md:mt-2 ">

                                <div className="inputboxDate border-[1px] border-[#4ab0b0] rounded-[6px]">
                                    <DatePicker
                                        name="dob"
                                        selected={
                                            formData.dob
                                                ? new Date(
                                                    formData.dob
                                                        .split("-")
                                                        .reverse()
                                                        .join("-")
                                                )
                                                : null
                                        } // Convert 'dd-MM-yyyy' string back to Date object
                                        onChange={handleDateChange1}
                                        dateFormat="dd-MM-yyyy"
                                        placeholderText="DOB(dd-mm-yyyy)"
                                        className="w-full h-[40px] outline-none mb-2 text-[#234971] block indent-5 rounded-[5px]"
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={50}
                                        popperClassName="custom-datepicker"
                                    />
                                </div>
                            </div>

                            <div className="flex justify-center mt-6">
                                <button
                                    type="submit"
                                    className="text-[#11485B] bg-[#ffffff] lg:w-[300px] p-2 w-auto h-[40px] rounded-[20px] flex justify-center items-center cursor-pointer"
                                >
                                    <p className="text-[12px]">
                                        Request Quote
                                    </p>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </>
    )
}

export default ViewForm